import { render, staticRenderFns } from "./WeeklyTrendInsight.vue?vue&type=template&id=5034130a&scoped=true"
import script from "./WeeklyTrendInsight.vue?vue&type=script&lang=js"
export * from "./WeeklyTrendInsight.vue?vue&type=script&lang=js"
import style0 from "./WeeklyTrendInsight.vue?vue&type=style&index=0&id=5034130a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5034130a",
  null
  
)

export default component.exports